import React, { useState } from "react";
import styles from "../../../css/AddTripForm/FormField.module.css";
const CustomFileInput = ({ name, photoLink, photoLinkName, photoSourceName, onChange }) => {
    const [preview, setPreview] = useState(photoLink ?  `${photoLink}?t=${Date.now()}` : null);
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
          setPreview(URL.createObjectURL(file)); // Ustaw podgląd obrazu
          onChange(name, file); // Przekaż plik (File) do nadrzędnego komponentu
      }
  };
  
    const handleRemoveImage = () => {
      setPreview(null); // Clear preview
      onChange(name, null); // Pass null to parent
      onChange(photoSourceName, null);
      onChange(photoLinkName, null);
    };
  
    return (
      <div className={styles.fileInputWrapper}>
        {/* Hidden input */}
        <input
          type="file"
          id={name}
          name={name}
          className={styles.hiddenInput}
          onChange={handleFileChange}
          accept="image/*"
        />
  
        {/* Visible custom input */}
        <label htmlFor={name} className={styles.customInput}>
          {preview ? (
            <img
              src={preview}
              alt="Podgląd zdjęcia"
              className={styles.previewImage}
            />
          ) : (
            <div className={styles.placeholder}>
              <i className={`fas fa-image ${styles.imageIcon}`}></i>
              <span>Nie wybrano zdjęcia</span>
            </div>
          )}
        </label>
  
        {/* Remove Image Button */}
        {preview && (
          <button
            type="button"
            onClick={handleRemoveImage}
            className={styles.removeButton}
          >
            Usuń zdjęcie
          </button>
        )}
      </div>
    );
  };
  
  export default CustomFileInput;